import React from 'react';
import { Icon } from './Icon.js';
export const IconEnvelopeContent = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M2.5 10L12 16L21.5 10H22V20H2V10H2.5Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", fill: "none" }),
        React.createElement("path", { d: "M20 7.40137L18 8.66406V4H6V8.66406L4 7.40137V2H20V7.40137Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" }),
        React.createElement("path", { d: "M13 8H15", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M9 8H9.01", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconEnvelopeContent.js.map